<template lang="pug">
.editor-container(:style="{ height: height }")
  QuillEditor(
    ref="editor",
    v-model:content="content",
    content-type="html",
    :toolbar="toolbarOptions",
    theme="snow",
    :modules="modules",
    :enable="!disabled",
    :readOnly="disabled"
  )
</template>

<script lang="ts">
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import BlotFormatterModule from "quill-blot-formatter/dist/BlotFormatter";
type BlotFormatterCjsCompat = { default?: typeof BlotFormatterModule };
const BlotFormatter =
  (BlotFormatterModule as unknown as BlotFormatterCjsCompat).default ??
  BlotFormatterModule;

export default {
  components: {
    QuillEditor,
  },
  props: {
    modelValue: String,
    allowImages: Boolean,
    disabled: Boolean,
    height: {
      type: String,
      default: "min-content",
    },
  },
  data: function () {
    return {
      toolbarOptions: [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        ["blockquote", "code-block"],

        // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ list: "ordered" }, { list: "bullet" }],
        // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        // [{ 'direction': 'rtl' }],                         // text direction

        // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        // [{ 'font': [] }],
        [{ align: [] }],

        ["clean"], // remove formatting button
        ...(this.allowImages ? [["image"]] : []),
      ],
      modules: this.allowImages
        ? {
            name: "blotFormatter",
            module: BlotFormatter,
            options: {
              /* options */
            },
          }
        : undefined,
    };
  },

  computed: {
    content: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },

  methods: {
    focus() {
      this.$refs.editor.focus();
    },
  },
};
</script>

<style scoped>
.editor-container {
  display: flex;
  flex-direction: column;
}

.editor-container ::v-deep .ql-container {
  /* NOTE: The header of the editor is 42px */
  min-height: calc((100%) - 42px);
}
</style>
